<template>
	<v-layout wrap class="mb-1">
		<v-flex
			v-for="option in filteredOptions"
			:key="option.slug"
			xs12
			:sm6="option.field_configuration.type === 'int'"
		>
			<v-text-field
				:label="option.field_configuration.label"
				outline
				hide-details
				:value="option.field_configuration.default"
				v-model="configuration[option.slug]"
				type="text"
				:disabled="option.is_disabled === 1"
				v-if="option.field_configuration.type === 'string'"
			>
				<template
					v-slot:append
					v-if="option.field_configuration.tooltip"
				>
					<tooltip-menu :title="option.name">
						{{ option.field_configuration.tooltip }}
					</tooltip-menu>
				</template>
			</v-text-field>
			<v-text-field
				:label="option.field_configuration.label"
				outline
				hide-details
				:value="option.field_configuration.default"
				v-model.number="configuration[option.slug]"
				type="number"
				:min="option.field_configuration.min"
				:max="option.field_configuration.max"
				:disabled="option.is_disabled === 1"
				v-if="option.field_configuration.type === 'int'"
				@blur="validateValue(option)"
			>
				<template v-slot:append>
					<tooltip-menu :title="option.name">
						<span v-if="option.field_configuration.tooltip">
							{{ option.field_configuration.tooltip }}
							<hr />
						</span>
						<span>
							The number must be between
							<b>{{ option.field_configuration.min }}</b> and
							<b>{{ option.field_configuration.max }}</b
							>.
						</span>
					</tooltip-menu>
				</template>
			</v-text-field>
			<v-checkbox
				:label="option.field_configuration.label"
				outline
				hide-details
				:input-value="option.field_configuration.default"
				:disabled="option.is_disabled === 1"
				v-model="configuration[option.slug]"
				v-if="option.field_configuration.type === 'bool'"
			>
				<template
					v-slot:append
					v-if="option.field_configuration.tooltip"
				>
					<tooltip-menu :title="option.name">
						{{ option.field_configuration.tooltip }}
					</tooltip-menu>
				</template>
			</v-checkbox>
			<v-select
				:label="option.field_configuration.label"
				outline
				:hide-details="!showErrors || !errors[option.slug]"
				:value="option.field_configuration.default"
				v-model="configuration[option.slug]"
				item-text="name"
				return-object
				:items="filteredSelect(option)"
				:disabled="option.is_disabled === 1"
				v-if="option.field_configuration.type === 'select'"
				:error-messages="showErrors ? errors[option.slug] : []"
			>
				<template
					v-slot:append-outer
					v-if="option.field_configuration.tooltip"
				>
					<tooltip-menu :title="option.name">
						{{ option.field_configuration.tooltip }}
					</tooltip-menu>
				</template>
			</v-select>
		</v-flex>
	</v-layout>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import TooltipMenu from "@components/partials/TooltipMenu";

var { quoteBuilder } = require("@root/mixins");

export default {
	mixins: [quoteBuilder],

	data() {
		return {};
	},

	props: {
		options: {
			default() {
				return {};
			}
		},

		configuration: {
			default() {
				return {};
			}
		},

		errors: {
			default() {
				return {};
			}
		},

		showErrors: {
			default() {
				return false;
			}
		}
	},

	computed: {
		filteredOptions() {
			// !(
			// 	option.hidden ||
			// 	(!option.value && option.is_disabled)
			// );

			// const optionsMap = {};

			// for (const option of this.options) {
			//   optionsMap[option.slug] = option;
			// }

			// if (
			//   optionsMap["hoist-lift"] &&
			//   optionsMap["optional-nickel-plated-load-chain"]
			// ) {
			//   delete optionsMap["hoist-lift"];
			// }

			// return Object.values(optionsMap);

			// const selectOptions = [];
			// const restOptions = [];

			// for (const option of this.options) {
			//   if (option.hidden) {
			//     continue;
			//   }

			//   const { type } = option.field_configuration;

			//   if (type === "select") {
			//     selectOptions.push(option);
			//   } else {
			//     restOptions.push(option);
			//   }
			// }

			// return [...selectOptions, ...restOptions];

			return this.options;
		}
	},

	methods: {
		emitInput($event, data, slug) {
			// console.log('emitInput', $event, data, configuration);
			if (slug === "pendant-pricing-with-qd-plug") {
				const vals = $event.value.split(/(1A)/).reduce((a, c) => {
					if (c === "1A") {
						a.push(c);
					} else {
						a = a.concat(c.split(""));
					}
					return a;
				}, []);
				let on_off_switch = null;
				const motions = [];

				vals.forEach(m =>
					m === "1A" ? (on_off_switch = m) : motions.push(m)
				);

				// update number of motions
				const num_of_motions = this.options.find(
					opt => opt.slug === "number-of-motions"
				);
				// console.log("number of motions", num_of_motions);
				// hey, it's existed.
				if (num_of_motions) {
					let toSend = {
						name:
							motions.length === 2
								? "Two Motion"
								: "Three Motion",
						price: 0,
						value: "'" + motions.length + "'"
					};
					this.configuration[num_of_motions.slug] = toSend;
					// this.$emit("input", this.configuration[num_of_motions.slug])
				}
			}
		},
		validateValue(option) {
			const value = this.configuration[option.slug];

			if (value < option.field_configuration.min) {
				this.$set(
					this.configuration,
					option.slug,
					option.field_configuration.min
				);
			} else if (value > option.field_configuration.max) {
				this.$set(
					this.configuration,
					option.slug,
					option.field_configuration.max
				);
			}
		},

		filteredSelect(option) {
			const {
				field_configuration: { values },
				restriction
			} = option;

			if (restriction && restriction.options) {
				const optionsSet = new Set(restriction.options);

				return values.filter(({ value }) => optionsSet.has(value));
			}

			return values;
		}
	},

	components: { TooltipMenu },
	watch: {
		configuration: {
			deep: true,
			// immediate: true,
			handler(configuration) {
				const watch_nested = "pendant-pricing-with-qd-plug";
				if (
					watch_nested in configuration &&
					configuration[watch_nested]
				) {
					// console.log(
					// 	"changing buttons",
					// 	configuration["pendant-pricing-with-qd-plug"]
					// );
					// this.$emit()
				}
			}
		}
	}
};
</script>
